<div class="clearfix">
  <customer-select class="fr sm:w-full mx:mr-8"></customer-select>
</div>
<div class="order-success-content flex-center text-base sm:px-4">
  <img src="assets/order-success.png" class="success sm:mt-[52px] mx:mt-[150px]" />
  <p class="title font-bold">{{"ORDER_SUCCESS_TIPS" | translate}}</p>
  <p class="font-bold mb-[22px]">{{"ORDER_SUCCESS_TIPS1" | translate}}</p>
  <p class="font-bold mb-[22px]">{{"ORDER_SUCCESS_TIPS2" | translate}}: <span class="color-blue cursor-pointer" (click)="goHistoryDetail(orderNo)">#{{orderNo}}</span></p>
  <p class="w-full mx:w-[769px] sm:w-full text-center mb-[22px]">{{"ORDER_SUCCESS_TIPS3" | translate}}</p>
  <p class="w-full mx:w-[769px] sm:w-full text-center mb-[22px]">{{"ORDER_SUCCESS_TIPS4" | translate}}</p>
    <div class="flex-center w-full mx:mb-[180px] sm:mb-8 mx:w-[769px] sm:w-full">
      <div class="default-small-btn mx:w-[212px] sm:w-[50%]" (click)="exportExcel()"><svg-icon [isUrl]="false"  [iconName]="'new/download.svg'" class="mr-2"></svg-icon>{{"EXPORT" | translate}}</div>
      <div class="primary-small-btn mx:w-[212px] sm:w-[50%] ml-4 sm:!px-3" (click)="goHistory()"><svg-icon [isUrl]="false"  [iconName]="'new/history.svg'"  class="mr-2"></svg-icon>{{"ORDER_HISTORY" | translate}}</div>
    </div>
</div>
